var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconinline = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2651 5.5H6.76514C5.37764 5.5 4.26514 6.625 4.26514 8V23C4.26514 24.375 5.37764 25.5 6.76514 25.5H24.2651C25.6401 25.5 26.7651 24.375 26.7651 23V8C26.7651 6.625 25.6401 5.5 24.2651 5.5ZM14.2651 14.25H12.3901V13.625H9.89014V17.375H12.3901V16.75H14.2651V18C14.2651 18.6875 13.7026 19.25 13.0151 19.25H9.26514C8.57764 19.25 8.01514 18.6875 8.01514 18V13C8.01514 12.3125 8.57764 11.75 9.26514 11.75H13.0151C13.7026 11.75 14.2651 12.3125 14.2651 13V14.25ZM23.0151 14.25H21.1401V13.625H18.6401V17.375H21.1401V16.75H23.0151V18C23.0151 18.6875 22.4526 19.25 21.7651 19.25H18.0151C17.3276 19.25 16.7651 18.6875 16.7651 18V13C16.7651 12.3125 17.3276 11.75 18.0151 11.75H21.7651C22.4526 11.75 23.0151 12.3125 23.0151 13V14.25Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.inline.c9f1dd74edeb45aead512b1c5a46b530.svg";